import React from "react";
import { useTranslation } from "react-i18next";

import { ExternalLinkIconHollow } from "../../assets/icons";
import { Accordion } from "./index";

const FollowUpGoals = ({ isPdf = false, platform, mftPublicTeam }) => {
  const { t } = useTranslation();

  const followUpGoals = platform === "mft" ?
    t("mft.followUpGoals", { returnObjects: true }) :
    t("followUpGoals", { returnObjects: true });

  const content = () => {
    const { description, linkText, linkUrl } = followUpGoals?.content || {};

    return (
      <div id="followUpGoals" className="w-full">
        {!isPdf && (
          <p className="mb-4 text-gray-250" dangerouslySetInnerHTML={{ __html: description }} />
        )}

        {linkText && linkUrl && (
          <div className="w-full flex gap-1 items-center justify-between h-12 mt-4 font-medium">
            <div
              className="border-2 border-gray-250/30 bg-orange-700 rounded-lg p-2 text-gray-250 text-sm font-medium w-full h-full flex items-center"
              dangerouslySetInnerHTML={{ __html: linkText }}
            />
            <a href={linkUrl} target="_blank" rel="noreferrer" className="w-12 h-12">
              <div className="bg-orange-100 rounded-full p-2 text-white-100 text-base font-medium w-full h-full cursor-pointer flex items-center justify-center">
                <span className="w-6 h-6">
                  <ExternalLinkIconHollow />
                </span>
              </div>
            </a>
          </div>
        )}
      </div>
    );
  };

  return (
    <div
      id="followUpGoals"
      className={
        isPdf ? "h-screen px-4 flex flex-col justify-start items-center overflow-hidden" : "mb-12"
      }>
      <Accordion
        title={isPdf ? null : followUpGoals?.title}
        icon={isPdf ? null : followUpGoals?.icon}
        content={content()}
        isPdf={isPdf}
        backgroundColor={"#ffffff"}
      />
    </div>
  );
};

export default FollowUpGoals;
